import './AutoSlider.css';
import { useBetween } from "use-between";
import { useSelector } from "react-redux";
import slide1 from './slider1.jpg'
import slide2 from './slider2.jpg'
import slide3 from './slider3.jpg'

function AutoSlider() {
  const { mainRef } = useBetween(
    useSelector((state) => state.useSharedLang)
  );

    return (
      <div className="AutoSlider" ref={mainRef}>
        <div
          id="carouselExampleCaptions"
          className="carousel carousel-dark slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-indicators">
            <button
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide-to="0"
              className="active"
              aria-current="true"
              aria-label="Slide 1"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide-to="1"
              aria-label="Slide 2"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide-to="2"
              aria-label="Slide 3"
            ></button>
          </div>
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img
                src={slide1}
                className="d-block slider-pictures"
                alt="..."
              />
              {/* <div className="carousel-caption d-none d-md-block">
                            <h5>{translate('first-slider-label', locale)}</h5>
                            <p>{translate('first-slider-content', locale)}</p>
                        </div> */}
            </div>
            <div className="carousel-item">
              <img
                src={slide2}
                className="d-block slider-pictures"
                alt="..."
              />
              {/* <div className="carousel-caption d-none d-md-block">
                            <h5>{translate('second-slider-label', locale)}</h5>
                            <p>{translate('second-slider-content', locale)}</p>
                        </div> */}
            </div>
            <div className="carousel-item">
              <img
                src={slide3}
                className="d-block slider-pictures"
                alt="..."
              />
              {/* <div className="carousel-caption d-none d-md-block">
                            <h5>{translate('third-slider-label', locale)}</h5>
                            <p>{translate('third-slider-content', locale)}</p>
                        </div> */}
            </div>
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    );
}

export default AutoSlider;
